import type { ReactNode } from 'react'

export const ErrorBox = ({ errors }: ErrorBoxProps) => {
  if (!errors || errors.length === 0) {
    return null
  }

  return (
    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-sm relative my-4 transition-opacity duration-500 break-words">
      <strong className="font-bold">
        Please fix the following {errors.length > 1 ? 'errors' : 'error'}:
      </strong>
      <ul className={errors.length === 1 ? '' : 'mt-2 list-disc list-inside'}>
        {errors.map((error, index) => {
          return <li key={`error-${index}`} className="break-words">{error}</li>
        })}
      </ul>
    </div>
  )
}

interface ErrorBoxProps {
  errors: ReactNode[]
}
